import { render, staticRenderFns } from "./Scoreboard.vue?vue&type=template&id=4c1ee979&scoped=true&"
import script from "./Scoreboard.vue?vue&type=script&lang=js&"
export * from "./Scoreboard.vue?vue&type=script&lang=js&"
import style0 from "./Scoreboard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Scoreboard.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./Scoreboard.vue?vue&type=style&index=2&id=4c1ee979&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1ee979",
  null
  
)

export default component.exports